import styled from "styled-components";
import styleConst from "constants/style";

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 500px;
  height: auto;

  background-color: white;
  border-radius: 16px;
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.12);
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px;
  text-align: center;
`;

export const Title = styled.h2`
  font-family: ${styleConst.fonts.montserrat};
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 16px;
  margin-top: 16px;
  color: ${styleConst.colors.dark};
`;

export const Description = styled.p`
  font-family: ${styleConst.fonts.montserrat};
  font-size: 16px;
  font-weight: 400;
  color: ${styleConst.colors.dark};
  margin-bottom: 32px;
`;

export const CloseButton = styled.button`
  padding: 12px 24px;
  font-family: ${styleConst.fonts.montserrat};
  font-size: 16px;
  font-weight: 600;
  color: white;
  background-color: ${styleConst.colors.primary};
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${styleConst.colors.primaryDark};
  }
`;
